module.exports = __webpack_public_path__ + "static/dashboard_bn1@2x-f9e0dc4eb1d8b02f51dd1ccd99c42968.jpg";